module.exports = __webpack_public_path__ + "static/img/price-bg.a3c7951.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/price-bg.png
// module id = pR8Y
// module chunks = 0